{
  "dashboard": "Tableau de bord",
  "orders": "Commandes",
  "csvVendorOverride": "Import CSV — Réassignation Fournisseur",
  "merchants": "Marchands",
  "vendors": "Fournisseurs",
  "stores": "Boutiques",
  "orderList": "Liste des commandes",
  "orderSettings": "Paramètres de commande",
  "vendorMapping": "Mappage Fournisseur",
  "auditLog": "Journal d'audit",
  "shipping": {
    "group": "Expédition",
    "price": "Prix d'expédition",
    "trackRouting": "Suivi du routage",
    "config": "Configuration",
    "rateTable": "Grille tarifaire",
    "rateTable2": "Rate Table 2",
    "rt2Routing": "Routage",
    "rt2Margin": "Rapport de marge",
    "rt2History": "Historique",
    "rt2Rate": "Grille tarifaire",
    "comingSoon": "Bientôt disponible"
  },
  "billing": "Facturation",
  "settings": "Paramètres",
  "groups": {
    "finance": "Finance",
    "billing": "Facturation",
    "products": "Blueprints",
    "pricing": "Tarification",
    "reports": "Rapports",
    "system": "Système",
    "support": "Support",
    "operations": "Opérations",
    "salesCrm": "Ventes / CRM",
    "affiliate": "Affiliation",
    "homeManagement": "Gestion de l'accueil",
    "monitoring": "Supervision"
  },
  "finance": {
    "invoices": "Factures",
    "agingReport": "Balance âgée",
    "creditMemos": "Avoirs",
    "refundTasks": "Remboursements",
    "pendingApprovals": "En attente d'approbation",
    "paymentRequests": "Demandes de paiement",
    "transactions": "Transactions",
    "payouts": "Versements fournisseurs",
    "topupReviews": "Revues de recharge",
    "credits": "Crédits",
    "gateways": "Passerelles de paiement",
    "transferGroups": "Groupes de transfert",
    "legalEntities": "Entités juridiques",
    "topupQueue": "File de recharge",
    "withdrawQueue": "Retraits marchands",
    "chargebacks": "Rétrofacturations",
    "fraudSettings": "Paramètres anti-fraude",
    "whitelist": "Whitelist",
    "imapConfig": "Configuration IMAP",
    "fxRates": "Taux de change"
  },
  "products": {
    "categories": "Catégories",
    "blueprints": "Modèles produit",
    "options": "Options",
    "productApproval": "Approbation produit",
    "productsSpecial": "Produits spéciaux",
    "bundles": "Lots",
    "mapping": "Mapping",
    "collections": "Collections",
    "addOns": "Add-ons",
    "pricing": "Tarification",
    "techniques": "Techniques",
    "templates": "Modèles",
    "root": "Produits",
    "materials": "Matériaux",
    "regionErrors": "Erreurs de zone",
    "checkTypes": "Types de vérification",
    "printAreas": "Zones d'impression",
    "locations": "Emplacements"
  },
  "pricing": {
    "prices": "Prix",
    "pricesV2": "Prix V2",
    "blueprintCost": "Coût des modèles",
    "packingGroups": "Groupes d'emballage",
    "pricingConfig": "Configuration des prix"
  },
  "reports": {
    "analytics": "Analytique",
    "orderWarnings": "Alertes commandes",
    "syncErrorReports": "Rapports d'erreurs de synchronisation",
    "auditLogs": "Journaux d'audit",
    "accountantActivity": "Activité comptable",
    "exportCenter": "Centre d'export"
  },
  "system": {
    "users": "Utilisateurs",
    "roles": "Rôles",
    "settings": "Paramètres système",
    "announcements": "Annonces",
    "dualApproval": "File d'approbation double",
    "emailTemplates": "Modèles d'e-mail",
    "rolesMatrix": "Rôles et permissions",
    "adminMgmt": "Gestion des admins",
    "featureFlags": "Feature flags",
    "health": "État du système",
    "maintenance": "Mode maintenance",
    "bugTracker": "Suivi des bugs"
  },
  "support": {
    "dashboard": "Tableau de support",
    "tickets": "Tickets",
    "departments": "File des services",
    "inbox": "Boîte de réception",
    "performance": "Performance",
    "configurations": "Configurations"
  },
  "assignSalesCs": "Affecter Sale & CS",
  "navAria": "Navigation admin",
  "superAdminOnly": "Super Admin uniquement",
  "operations": {
    "shipmentTracking": "Suivi des expéditions",
    "pendingManualAssign": "Attribution manuelle en attente"
  },
  "sales": {
    "overview": "Aperçu",
    "leads": "Prospects",
    "deals": "Affaires",
    "salerGroups": "Groupes de vendeurs",
    "calendar": "Calendrier",
    "targets": "Objectifs",
    "leaderboard": "Classement",
    "gmvReport": "Rapport GMV",
    "operations": "Opérations",
    "merchants": "Marchands commerciaux",
    "benefits": "Avantages",
    "reports": "Rapports",
    "settings": "Paramètres"
  },
  "affiliate": {
    "hub": "Hub d'affiliation",
    "list": "Liste des affiliés",
    "payoutQueue": "File d'attente des versements",
    "shortLinks": "Liens courts",
    "abuseReport": "Signalement d'abus"
  },
  "homeManagement": {
    "homepage": "Page d'accueil",
    "ebooks": "Ebooks",
    "blog": "Blog",
    "help": "Centre d'aide",
    "stories": "Témoignages",
    "faq": "FAQ",
    "sellerSurvey": "Enquête vendeurs",
    "footer": "Pied de page",
    "contact": "Contact",
    "pages": "Pages"
  },
  "inventory": {
    "overview": "Aperçu de l'inventaire",
    "group": "Inventaire",
    "stockLevel": "Niveaux de stock",
    "valuation": "Valorisation",
    "movement": "Mouvements",
    "aging": "Ancienneté du stock",
    "turnover": "Rotation des stocks"
  },
  "monitoring": {
    "queueJobs": "Files & tâches",
    "webhookLogs": "Journaux Webhook",
    "syncErrors": "Erreurs de synchronisation",
    "imapParser": "Analyseur IMAP"
  },
  "vendorsServices": "Service"
}
